import { STORAGE_KEY_NAV_FAVORITES } from 'src/config/storage-keys';

import type { NavSection } from './config-navigation';

const getFavoriteId = (item: NavSection['items'][number]) =>
  item.path === '#' ? `group:${item.title}` : `path:${item.path}`;

export const getStoredFavoriteIds = (): string[] => {
  if (typeof window === 'undefined') return [];

  try {
    const value = window.localStorage.getItem(STORAGE_KEY_NAV_FAVORITES);
    const parsedValue = value ? JSON.parse(value) : [];

    return Array.isArray(parsedValue) ? parsedValue.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

export const persistFavoriteIds = (favoriteIds: string[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY_NAV_FAVORITES, JSON.stringify(favoriteIds));
  } catch {
    // Mantém a interação funcional quando o armazenamento não estiver disponível.
  }
};

export const groupNavDataByFavorites = (data: NavSection[], favoriteIds: string[]): NavSection[] => {
  const sectionsWithFavoriteIds = data.map((section) => ({
    ...section,
    items: section.items.map((item) => (item.icon ? { ...item, favoriteId: getFavoriteId(item) } : item)),
  }));

  const favoriteItems = sectionsWithFavoriteIds.flatMap((section) =>
    section.items.filter((item) => item.favoriteId && favoriteIds.includes(item.favoriteId))
  );

  const sectionsWithoutFavoriteItems = sectionsWithFavoriteIds
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => !item.favoriteId || !favoriteIds.includes(item.favoriteId)),
    }))
    .filter((section) => section.items.length > 0);

  return favoriteItems.length > 0
    ? [{ subheader: 'Favoritos', items: favoriteItems }, ...sectionsWithoutFavoriteItems]
    : sectionsWithoutFavoriteItems;
};
